import { render } from "./ClinicFormFields.vue?vue&type=template&id=0d01214e"
import script from "./ClinicFormFields.vue?vue&type=script&lang=js"
export * from "./ClinicFormFields.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__